import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Card, Flex } from 'pcln-design-system'
import { Booking } from './types'
import { buildContent } from './utils'
import useCrossSellInventory from './useCrossSellInventory'
import analytics from '../../utils/analytics'
import Inventory from './Inventory'
import NoInventoryFallback from './NoInventoryFallback'
import BookingInfo from './BookingInfo'
import { ANALYTICS_CATEGORY_HOME } from '../../constants/analytics'

const Wrapper = styled(Card)`
  border-radius: 4px;
`

const GradientWrapper = styled(Flex)`
  position: relative;
  height: 6px;
  background-color: #007aff;
  background-image: linear-gradient(to right, #007aff, #00b500);
  border-radius: 4px 4px 0 0;
`

export default function CrossSell({ booking }: { booking: Booking }) {
  const {
    product,
    date,
    headline,
    offerToken,
    subHeadline,
    xSellMessaging,
    xSellTarget,
    xSellUrl
  } = buildContent(booking)

  const inventory = useCrossSellInventory(booking)
  const { listings, offerNum } = inventory
  const xSellProduct = xSellTarget
    .substring(0, xSellTarget.length - 1)
    .toLowerCase()

  useEffect(() => {
    if (listings.length) {
      analytics.fireEvent({
        action: 'upcoming trip',
        category: ANALYTICS_CATEGORY_HOME,
        label: 'xsell inventory display'
      })
    }
  }, [listings.length])

  return (
    <Wrapper
      className="cross-sell-container"
      mx={0}
      my={[3, 0]}
      color="background.lightest"
      boxShadowSize="md"
    >
      <GradientWrapper />
      <Flex flexDirection={['column', null, 'row']}>
        <BookingInfo
          product={product}
          date={date}
          headline={headline}
          subHeadline={subHeadline}
        />
        {listings.length ? (
          <Inventory
            listings={listings}
            offerNum={offerNum}
            xSellMessaging={xSellMessaging}
            xSellProduct={xSellProduct}
            xSellUrl={xSellUrl}
            offerToken={offerToken}
          />
        ) : (
          <NoInventoryFallback
            xSellMessaging={xSellMessaging}
            xSellTarget={xSellTarget}
            xSellUrl={xSellUrl}
            xSellProduct={product}
            offerNum={offerNum}
          />
        )}
      </Flex>
    </Wrapper>
  )
}
